module.exports = __webpack_public_path__ + "static/media/Nails02.1a0a6414.jpeg";